import { Link } from "react-router-dom";

const LOGO_WHITE = "/brand/MFP_white.svg";

export default function Header() {
  return (
    <header
      className="sticky top-0 z-40 bg-mfp-bg/90 backdrop-blur border-b border-white/10"
      data-testid="site-header"
    >
      <div className="max-w-6xl mx-auto px-4 md:px-8 h-16 md:h-20 flex items-center justify-between">
        <Link to="/" aria-label="MediaFly Production Startseite" data-testid="header-logo-link">
          <img
            src={LOGO_WHITE}
            alt="MediaFly Production"
            width="160"
            height="44"
            className="h-9 md:h-11 w-auto"
            loading="eager"
            fetchPriority="high"
          />
        </Link>
        <div className="flex items-center gap-4 text-[11px] uppercase tracking-widest text-mfp-muted font-semibold">
          <span className="hidden sm:inline">Content. Reels. Leads.</span>
          <span
            className="h-2 w-2 bg-mfp-gold inline-block"
            aria-hidden="true"
            data-testid="header-red-dot"
          />
        </div>
      </div>
    </header>
  );
}
